module.exports = "<app-pdf-view class=\"\" [src]=\"securedSrc\"></app-pdf-view>\n"